export const reportFileNameParser = (filePath: string | null | undefined) => {
  const normalizedPaths = (filePath ?? '').trim().split('/');
  const fullFileName = normalizedPaths.at(-1) || '';

  const lastDotIndex = fullFileName.lastIndexOf('.');
  const fileExtension =
    lastDotIndex === -1
      ? ''
      : fullFileName.substring(lastDotIndex + 1).toLowerCase();

  return {
    fileExtension,
    fileName: fileExtension ? `Report.${fileExtension}` : 'Report',
  };
};
